import React, { useState } from 'react';
import styles from './styles.module.scss';
import Text from 'components/typografy/text';
import classNames from 'classnames';
import {toTitleCase} from 'helpers';
import {ExternalLink} from 'lucide-react';
import {getWithdrawalLink} from 'api/payment';
import { toaster } from 'components/chakra-ui/toaster';

const DialogContent: React.FC<{data: any}> = ({data}) => {

  const [linkCache, setLinkCache] = useState<Record<string, string>>({});  // Cache for links to avoid multiple requests (a dictionary of withdrawal_id and link, both strings)
  
  // Handle withdrawal link click (send to external link)
  const handleLinkClick = (withdrawal_id: string) => {
    if (linkCache[withdrawal_id]) {
      // Already cached, just open it
      window.open(linkCache[withdrawal_id], '_blank');
      return;
    }  
    // Show toast modal "Loading..."
    toaster.create({
      description: 'Loading...',
      duration: 5000,
      type: 'success',
      action: {
        label: 'Close',
        onClick: () => {}
      }
    });
    getWithdrawalLink(withdrawal_id).then((res) => {
      if (res?.link) {
        // Dismiss the toast modal
        toaster.dismiss();
        // Open the link in a new tab
        window.open(res.link, '_blank');
        // Cache the link for future use for successful requests (to avoid multiple requests)
        setLinkCache((prev) => ({ ...prev, [withdrawal_id]: res.link }));
      } 
    })
    .catch((error) => {
      // Avoid unhandled promise rejections (error will be displayed in toast via the interceptor)
    });
  };
  
  return (
    <div className={styles.wrapper}>
      <div className={styles.row}>
        <Text variant={'large'} nativeClassname={styles.colorWhite}>
          <>
            Withdrawal Details
          </>
        </Text>
      </div>

      <div className={styles.row}>
        <Text variant={'large'} nativeClassname={styles.colorWhite}>
          Vendor
        </Text>
        <Text variant={'large'} nativeClassname={classNames(styles.text)}>
          {toTitleCase(data.vendor)}
        </Text>
      </div>


      <div className={styles.row}>
        <Text variant={'large'} nativeClassname={styles.colorWhite}>
          Amount
        </Text>
        <Text variant={'large'} nativeClassname={classNames(styles.text)}>
          ${Number(data.total_amount ?? 0).toFixed(2)}
        </Text>
      </div>
      <div className={styles.row}>
        <Text variant={'large'} nativeClassname={styles.colorWhite}>
          ID
        </Text>
        <Text variant={'large'}>
          {data.id}
        </Text>
      </div>
      <div className={styles.row}>
        <Text variant={'large'} nativeClassname={styles.colorWhite}>
          Time
        </Text>
        <Text variant={'large'} nativeClassname={classNames(styles.toRight)}>
          {data.created_at}
        </Text>
      </div>
      <div className={styles.row}>
        <Text variant={'large'} nativeClassname={styles.colorWhite}>
          Link
        </Text>
        <div
            className={styles.ExternalLink}
            onClick={() => handleLinkClick(data.id)}
          >
            <ExternalLink />
        </div>
      </div>
      <div className={styles.row}>
        <Text variant={'large'} nativeClassname={styles.colorWhite}>
          Status
        </Text>
        <Text variant={'large'}>
          {toTitleCase(data.status)}
        </Text>
      </div>
    </div>
  );
};

export default DialogContent;
